import { REWARDS_SPENDING_RULE_REDEEM_TYPES } from "@apps/rewards/constants/rewardsSpendingRuleTypes";
import { RewardsSpendingRuleSchema } from "@apps/rewards/schemas/RewardsSpendingRuleSchema";
import { Infer, array, enums, object, string } from "superstruct";

export const RewardsSpendingRulesResponseSchema = object({
    rules: array(RewardsSpendingRuleSchema),
});

export type RewardsSpendingRulesResponseType = Infer<
    typeof RewardsSpendingRulesResponseSchema
>;

export const RewardsSpendingRulesRedeemResponseSchema = object({
    rewardType: enums(Object.values(REWARDS_SPENDING_RULE_REDEEM_TYPES)),
    rewardCode: string(),
});

export type RewardsSpendingRulesRedeemResponseType = Infer<
    typeof RewardsSpendingRulesRedeemResponseSchema
>;
